import Vue from 'vue'
import Vuex from 'vuex'
import {
  SET_RID,
  SET_MODE,
  SET_FB_USER
} from '@/store/mutation-types'
import room from '@/store/modules/room'
import rooms from '@/store/modules/rooms'
import user from '@/store/modules/user'
import media from '@/store/modules/media'
import quizzes from '@/store/modules/quizzes'
import quizbank from '@/store/modules/quizbank'
import watchers from '@/store/modules/watchers'
import chat from '@/store/modules/chat'
import chatOption from '@/store/modules/chatOption'
import result from '@/store/modules/result'
import { firebaseDb, firebaseTestDb } from '@/vendor/firebase'
import { firebaseMutations } from 'vuexfire'
import l from '@/vendor/logger'

Vue.use(Vuex)

export let db

// mode
// TEST
// PROD

const state = {
  mode: null,
  rid: null,
  userToken: null
}

const getters = {
}

const mutations = {
  ...firebaseMutations,
  [SET_MODE] (state, mode) {
    state.mode = mode
  },
  [SET_RID] (state, rid) {
    state.rid = rid
  },
  [SET_FB_USER] (state, token) {
    state.userToken = token
  }
}

const actions = {
  setMode ({ commit }, mode) {
    if (db) {
      db.ref().off()
      // db.goOffline()
    }

    switch (mode) {
      case 'TEST': {
        db = firebaseTestDb
        // db.goOnline()
        break
      }
      case 'PROD': {
        db = firebaseDb
        // db.goOnline()
        break
      }
      default : {
        db = null
      }
    }

    commit(SET_MODE, mode)
    l.d('store/setMode', mode)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    room,
    rooms,
    user,
    media,
    quizzes,
    quizbank,
    watchers,
    result,
    chat,
    chatOption
  },
  strict: 'debug'
})
